module.exports = __webpack_public_path__ + "static/media/mail.8315ae29.svg";